import { apiGet } from './apiClient';

export interface ScheduleResponse {
  bookings: Array<{
    id: string;
    academyId: string;
    lessonId: string;
    customerId: string;
    studentId: string;
    termId?: string;
    sessionDate?: string;
    sessionId?: string | null;
    status: string;
    paymentStatus: string;
    totalAmount: number;
    nextLessonDate?: string;
    createdAt: string;
    updatedAt: string;
  }>;
  lessons: Record<string, {
    id: string;
    academyId: string;
    termId?: string;
    name: string;
    lessonType: string;
    skillLevel?: string;
    ballColor?: 'blue' | 'red' | 'orange' | 'green' | 'yellow';
    ageGroupId?: string | null;
    daysOfWeek?: number[];
    startTime: string;
    endTime: string;
    maxCapacity: number;
    startDate?: string | Date;
    endDate?: string | Date;
    numberOfSessions?: number;
    courtIds?: string[];
    coachIds?: string[];
    courtId?: string;
    coachId?: string;
  }>;
  terms: Record<string, {
    id: string;
    academyId: string;
    name: string;
    startDate: string;
    endDate: string;
    isActive: boolean;
  }>;
  overrides: Array<{
    id: string;
    lessonId: string;
    academyId: string;
    originalDate: string;
    overrideType: 'cancelled' | 'postponed';
    reason?: string;
    newDate?: string;
    newStartTime?: string;
    newEndTime?: string;
  }>;
  students?: Record<string, string>;
  coaches?: Record<string, string>;
  courts?: Record<string, string>;
  academySettings: Record<
    string,
    {
      makeupLessonEnabled: boolean;
      makeupNotificationDeadlineHours: number;
      makeupCreditExpiryDays: number;
      makeupCreditExpiryMode: 'days' | 'end_of_term';
    }
  >;
  makeupOccurrences?: Array<
    | { bookingId: string; date: string }
    | { makeupSessionReservationId: string; lessonId: string; date: string }
  >;
  makeupSessionReservations?: Array<{
    id: string;
    academyId: string;
    lessonId: string;
    termId: string;
    studentId: string;
    customerId: string;
    sessionDate: string;
    makeupCreditId: string;
    status: string;
    createdAt: string;
    updatedAt: string;
  }>;
  reportedAbsenceOccurrences?: Array<{ bookingId: string; date: string }>;
  excludedSessionOccurrences?: Array<{ bookingId: string; date: string }>;
  refundedBookingIds?: string[];
  privateLessonSessions?: Record<
    string,
    Array<{ id: string; sessionDate: string; startTime: string; endTime: string }>
  >;
}

export const scheduleService = {
  async getMySchedule(options?: {
    studentId?: string;
    academyId?: string;
  }): Promise<ScheduleResponse> {
    const params: Record<string, string> = {};
    if (options?.studentId) params.studentId = options.studentId;
    if (options?.academyId) params.academyId = options.academyId;
    const response = await apiGet<ScheduleResponse>('/bookings/my-schedule', { params });
    if (!response.success || !response.data) {
      throw new Error('Failed to fetch schedule');
    }
    return response.data;
  },
};
